import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import * as PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Modal from 'react-modal';

import { toggleSecurityModal, updateSecurityGroup } from '../../../../actions/SecurityGroupActions';
import { fetchUsers } from '../../../../api/AuthenticationApi';
import { firstTdStyles, fontStyles, iconStyles, tableHeaderStyles, tdStyles, tdLinkStyles } from './styles/Table.css';
import Button from '../../../common/Button';
import { mutedHeaderStyles } from '../../../common/styles/Header.css';
import { modalStyles } from './styles/Modal.css';
import { theadStyles, trStyles } from './styles/ModalTable.css';
import { BackgroundColors } from '../../../../constants/Enums';
import PaginationItem from '../../../common/PaginationItem';

class SecurityGroupModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            users: [],
            availableUsers: [],
            securityGroupUsers: [],
            visibleRows: [],
            filteredRows: [],
            filterValue: '',
            selectedUsers: [],
            activePage: 1,
            usersPerPage: 5,
            pageCount: 1
        };
    }

    filter = filterValue => {
        const users = this.state.availableUsers;
        const value = filterValue.toUpperCase();
        const filteredRows = users.filter(user => {
            return `${user.firstName} ${user.lastName}`.toUpperCase().indexOf(value) > -1
        });
        this.updateVisibleRows(filteredRows, filterValue);
    };

    updateVisibleRows = (filteredRows, filterValue) => {
        const { usersPerPage } = this.state;
        const rowCount = filteredRows.length;
        const pageCount = rowCount >= usersPerPage ? Math.ceil(rowCount / usersPerPage) : 1;
        const visibleRows = filteredRows.slice(0, usersPerPage);
        this.setState({ filteredRows, visibleRows, pageCount, filterValue });
    };

    getPaginationItems = (pageCount) => {
        let paginationItems = [];

        paginationItems.push(
            <PaginationItem
                key={0}
                action={this.toggleVisibleUsers}
                icon={'keyboard_arrow_left'}
                disabled={this.state.activePage === 1}
                pageValue={this.state.activePage - 1}
            />
        );
        for (let i = 1; i <= pageCount; i++) {
            paginationItems.push(
                <PaginationItem
                    action={this.toggleVisibleUsers}
                    pageValue={i}
                    text={i.toString()}
                    active={this.state.activePage === i}
                />
            )
        }

        paginationItems.push(
            <PaginationItem
                key={20}
                action={this.toggleVisibleUsers}
                icon={'keyboard_arrow_right'}
                disabled={this.state.activePage === pageCount}
                pageValue={this.state.activePage + 1}
            />
        );

        return paginationItems;
    };

    toggleVisibleUsers = pageNum => {
        if (!pageNum || pageNum > this.state.pageCount)
            return;
        const { filteredRows, usersPerPage } = this.state;
        const startIndex = (usersPerPage * pageNum) - usersPerPage;
        if (filteredRows && filteredRows.length >= startIndex) {
            const endIndex = filteredRows.length >= startIndex + usersPerPage
                ? startIndex + usersPerPage
                : filteredRows.length;
            const visibleRows = filteredRows.slice(startIndex, endIndex);
            this.setState({ visibleRows, activePage: pageNum });
        }
    };

    formatUsersForTable = users => {
        let rows = [];
        if (users != null && Array.isArray(users)) {
            users.forEach((user) => {
                const name = user.firstName + ' ' + user.lastName;
                const row = { name, id: user.id };
                rows.push(row);
            });
        }
        return rows;
    };

    //Get users not yet in current security group
    getAvailableUsers = (users, securityGroupUsers) => {
        let availableUsers = [];
        users.forEach(user => {
            if (!this.isUserInSecurityGroup(securityGroupUsers, user.id)) {
                availableUsers.push(user);
            }

        });
        return availableUsers;
    };

    isUserInSecurityGroup = (securityGroupUsers, userId) => {
        let isInSecurityGroup = false;
        securityGroupUsers.forEach(user => {
            if (user.userId === userId) {
                isInSecurityGroup = true;
            }
        });
        return isInSecurityGroup;
    };

    toggleUserSelected = userId => {
        let selectedUsers = this.state.selectedUsers;
        const index = selectedUsers.indexOf(userId);
        if (index > -1)
            selectedUsers.splice(index, 1);
        else
            selectedUsers.push(userId);
        this.setState({ selectedUsers });
    };

    isUserSelected = userId => {
        return this.state.selectedUsers.indexOf(userId) > -1;
    };

    addSelectedUsers = () => {
        const { selectedUsers } = this.state;

        const securityGroup = this.props.securityGroup;
        selectedUsers.forEach((userId) => {
            securityGroup.users.push({ userId });
        });

        this.props.updateSecurityGroup(securityGroup);
        this.props.toggleSecurityModal();
    };

    componentDidMount() {
        const { users, securityGroupUsers } = this.props;
        this.setState({ users, securityGroupUsers });
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.users !== this.state.users) {
            this.setState({ users: nextProps.users });
        }
        if (nextProps.securityGroupUsers && nextProps.securityGroupUsers !== this.state.securityGroupUsers) {
            this.setState({ securityGroupUsers: nextProps.securityGroupUsers });
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if ((prevState.securityGroupUsers !== this.state.securityGroupUsers) ||
            prevState.users !== this.state.users) {
            let { securityGroupUsers, users } = this.state;
            let availableUsers = this.getAvailableUsers(users, securityGroupUsers);

            this.setState({ availableUsers });
        }

        if (prevState.availableUsers !== this.state.availableUsers) {
            this.filter(this.state.filterValue);
        }
    }

    render() {
        const getTableRows = () => {
            let rows = [];
            let _rows = this.formatUsersForTable(this.state.visibleRows);
            _rows.forEach((row, i) => {
                rows.push(
                    <tr key={i}>
                        <td style={tdStyles(true)}>
                            <div className={'col-4 pl-4'}>
                                <input type={'checkbox'} className={'form-check-input'}
                                       onChange={() => this.toggleUserSelected(row.id)}
                                       checked={this.isUserSelected(row.id)} />
                                <label className={'form-check-label'} style={tdLinkStyles}
                                       onClick={() => this.toggleUserSelected(row.id)}>
                                    <span>{row.name}</span>
                                </label>
                            </div>
                        </td>
                    </tr>
                )
            });
            return rows;
        };

        const PaginationItems = this.getPaginationItems(this.state.pageCount);
        return (
            <Modal isOpen={true}
                   onRequestClose={this.props.toggleSecurityModal}
                   contentLabel={'Users Modal'}
                   style={modalStyles}>
                <div className={'container'}>
                    <div className={'row'}>
                        <div className={'col-sm-12'}>
                            <h5 style={mutedHeaderStyles} className={'mb-3'}>Add Users</h5>
                            <i className={'material-icons float-right'} style={iconStyles}
                               onClick={this.props.toggleSecurityModal}>
                                close
                            </i>
                        </div>
                    </div>
                    <table className="table table-striped">
                        <thead style={theadStyles}>
                        <tr>
                            <th style={tableHeaderStyles}>Name</th>
                        </tr>
                        <tr style={trStyles(BackgroundColors[1])}>
                            <td style={firstTdStyles}>
                                <input type={'text'} className={'form-control'} placeholder={'Search'}
                                       style={fontStyles}
                                       onChange={(e) => this.filter(e.target.value)} value={this.state.filterValue} />
                            </td>
                        </tr>
                        </thead>
                        <tbody>
                        {getTableRows()}
                        </tbody>
                    </table>
                    {this.state.visibleRows.length === 0 ? null :
                        <div className={'row mt-2'}>
                            <div className={'col-lg-3 offset-lg-9 col-6 offset-6'}>
                                <nav>
                                    <ul className={'pagination justify-content-end'}>
                                        {PaginationItems}
                                    </ul>
                                </nav>
                            </div>
                        </div>
                    }
                    <div className={'row'}>
                        <div className={'col-3 offset-9'}>
                            <Button text={'Add Selected'} classNames={['float-right']}
                                    additionalStyles={{ borderRadius: '3px' }}
                                    action={this.addSelectedUsers} />
                        </div>
                    </div>
                </div>
            </Modal>
        );
    }
}

SecurityGroupModal.propTypes = {
    users: PropTypes.array,
    securityGroup: PropTypes.object,
    securityGroupUsers: PropTypes.array,
    updateSecurityGroup: PropTypes.func,
    toggleSecurityModal: PropTypes.func
};

function mapStateToProps(state) {
    return {
        users: state.authenticationReducer.users,
        securityGroup: state.securityGroup.securityGroup,
        securityGroupUsers: state.securityGroup.securityGroup.users
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({ toggleSecurityModal, updateSecurityGroup, fetchUsers }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(SecurityGroupModal);
